import Vue from 'vue';
import Vuex from 'vuex';
import app from '@/stores/app';
import user from '@/stores/user';
import operator from '@/stores/operator';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
    'plugins': [createPersistedState({
        'paths': ['operator', 'app', 'user']
    })],
    'state': {
        'isPublic': true,
        'isNotifiedNotLoggedIn': false,
        'patientQueue': [],
        'currentPatient': {},
        'consultationDetails': []
    },
    'mutations': {
        setAppStatus (state, isPublic) {
            state.isPublic = isPublic;
        },
        updateLoginPromptStatus (state, isNotified) {
            state.isNotifiedNotLoggedIn = isNotified;
        },
        addQueue (state, queue) {
            state.patientQueue.push(queue);
        },
        deleteQueue (state, index) {
            state.patientQueue.splice(index, 1);
        },
        setCurrentPatient (state, patient) {
            state.currentPatient = patient;
        },
        addConsultationDetails (state, consultation) {
            state.consultationDetails.push(consultation);
        }
    },
    'actions': {

    },
    'modules': {
        app,
        user,
        operator
    },
    'getters': {
        shouldSendHeartbeat (state) {
            // return !state.isPublic;
            return false;
        }
    }
});
